import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from '@material-ui/core';
import { DashboardPanelEmptyState } from "../DashboardPanel/DashboardPanelEmptyState";

export interface DashboardDocumentsListEmptyProps {}

export const DashboardDocumentsListEmpty = (props: DashboardDocumentsListEmptyProps) => {
  const intl = useIntl();
  
  return (
    <DashboardPanelEmptyState iconname='downloadLarge'
                              linkText={intl.formatMessage({id: 'DashboardDocumentsEmptyButton'})}
                              linkUrl={intl.formatMessage({id: 'LinkDashboardEmptyDocuments'})}>
      <Typography component='h3' variant='h4'>
        <FormattedMessage id='DashboardDocumentsEmptyText' />
      </Typography>
    </DashboardPanelEmptyState>
  );
};
